import React from "react";
import path from '../../../img/partners/amoveo.png'

const Amoveo: React.FunctionComponent = () => (
  <img src={path} />
)

export default Amoveo
